import { Component, OnInit } from '@angular/core';
import { IWeissmanModalComponent } from '../../../../Compliance/WeissmanModalService';
import { BsModalRef } from 'ngx-bootstrap/modal';

export interface AppealRecommendationCommandCenterBulkUpdateResultConfirmationComponentParams {
    ignoredSites: Core.AppealRecommendationBulkUpdateSiteResultModel[];
}

@Component({
    selector: 'appeal-recommendation-command-center-bulk-update-result-confirmation',
    templateUrl: './aRCCBulkUpdateResultConfirmation.component.html',
    standalone: false
})
export class ARCCBulkUpdateResultConfirmationComponent implements OnInit, IWeissmanModalComponent<AppealRecommendationCommandCenterBulkUpdateResultConfirmationComponentParams, void> {
    constructor(private readonly _bsModalRef: BsModalRef) {
    }

    params: AppealRecommendationCommandCenterBulkUpdateResultConfirmationComponentParams;
    result: void;
    sites: Core.AppealRecommendationBulkUpdateSiteResultModel[];

    cancel() {
        this._bsModalRef.hide();
    }

    ngOnInit(): void {
        this.sites = this.params.ignoredSites.sort((x, y) => `${x.companyName + x.siteName}`.localeCompare(`${y.companyName + y.siteName}`));
    }
}
